import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const StyleEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const [formData, setFormData] = useState({
        Name: '',
    });


    useEffect(() => {
        fetchData('StyleApi', `/Style/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Style Details:', error);
            });
    }, []);

    const handleChange = event => {
        const { name, value, type } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        updateData('StyleApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/StyleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    return (

        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Style - Edit</h6>
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={handleSubmit}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> UPDATE
                    </Button>

                    <Button
                       
                        component={Link}
                        to="/StyleIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back To List
                    </Button>
                </div>
                {/* Render fetched data */}
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                <div>
                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Style Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Name} onChange={handleChange}
                                name='Name'
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                    </div>

                </div>
            </form>
        </div>

    );
};

export default StyleEdit;
